import { render } from "./EditArticle.vue?vue&type=template&id=15b6f071&scoped=true&ts=true"
import script from "./EditArticle.ts?vue&type=script&lang=ts"
export * from "./EditArticle.ts?vue&type=script&lang=ts"

import "./EditArticle.vue?vue&type=style&index=0&id=15b6f071&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b6f071"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QSelect,QItem,QItemSection,QBtn,QTooltip,QRadio,QToggle});
